import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface PurchaseCardOutterWrapperProps {
  isHighlight: boolean
}

export const PurchaseCardWrapper = styled.div<PurchaseCardOutterWrapperProps>`
  flex: 1 1 0;
  width: 100%;
  max-width: 480px;
  border: 1px solid ${Color.Grey200};
  border-radius: 16px;
  position: relative;
  background-color: ${({ isHighlight }) => isHighlight && Color.Lavender100};
`

export const HighlightedTextWrapper = styled.div`
  width: 100%;
  margin-top: ${Spacing.S4};
  position: absolute;
`

export const PurchaseCardInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100% - ${Spacing.S24});
  margin-top: ${Spacing.S24};
  padding: ${Spacing.S24};
  border-radius: 16px;
  background-color: ${Color.White};
`
